import { BooleanStatusDisplay } from "@/common/components/Status/BooleanStatusDisplay";
import { StatusDisplayProps } from "@/common/components/Status/StatusDisplay";
import { ApiEnumName } from "@/common/services/enum";
import { OperabilityStatus } from "@/core/api/generated/v1";

import GeneralStatusEnumValueInline, {
  GeneralStatusEnumValueInlineProps,
} from "../GeneralStatusEnumValueInline";
import { OperabilityStatusIndicator } from "./OperabilityStatusIndicator";

interface Props {
  status: OperabilityStatus | undefined;
  statusProps?: Partial<StatusDisplayProps>;
  enumInlineProps?: Partial<GeneralStatusEnumValueInlineProps>;
}

export function OperabilityStatusDisplay({ status, statusProps, enumInlineProps }: Props) {
  return (
    <BooleanStatusDisplay
      value={null}
      statusProps={{
        title: (
          <GeneralStatusEnumValueInline
            statusEnumTypeName={ApiEnumName.OperabilityStatus}
            status={status}
            {...enumInlineProps}
          />
        ),
        indicator: <OperabilityStatusIndicator status={status} />,
        ...statusProps,
      }}
    />
  );
}
